import { fork, take, put, getContext, call } from 'redux-saga/effects';
import { USER_REPLACED, updateUserMeta } from 'actions/user';
import { REPLACE_ACCOUNT_META } from 'constants/account/meta';
import { updateAccountMeta } from 'actions/account/meta';

function* setUserLastSeenTimestamp() {
  yield take(USER_REPLACED);
  yield put(updateUserMeta({ lastSeenTimestamp: Date.now() }));
}

function* setAccountLastSeenTimestamp() {
  const auth = yield getContext('auth');
  const isSpoofing = yield call(auth.isSpoofing);
  if (!isSpoofing) {
    yield take(REPLACE_ACCOUNT_META);
    yield put(updateAccountMeta({ lastSeenTimestamp: Date.now() }));
  }
}

export default function* lastSeen() {
  yield fork(setUserLastSeenTimestamp);
  yield fork(setAccountLastSeenTimestamp);
}
